import { z } from "zod";

/** Completion contract: complete_page, the attempt's one terminal signal. */

export const CompletePageInputSchema = z.object({
  summary: z.string().min(1),
  // Cross-checked against the findings actually submitted for this attempt.
  findingsCount: z.number().int().min(0),
});
export type CompletePageInput = z.infer<typeof CompletePageInputSchema>;

export const CompletePageOutputSchema = z.object({
  accepted: z.literal(true),
});
export type CompletePageOutput = z.infer<typeof CompletePageOutputSchema>;

// The loop's own measured effort, reported by the sandbox harness (not the
// model) after generateText returns or aborts. Accepted in any attempt state:
// a budget-exhausted loop reports after its wall-clock abort, and a completed
// one reports after complete_page flipped the status.
export const ReportLoopUsageInputSchema = z.object({
  steps: z.number().int().min(0),
  inputTokens: z.number().int().min(0),
  outputTokens: z.number().int().min(0),
});
export type ReportLoopUsageInput = z.infer<typeof ReportLoopUsageInputSchema>;

export const ReportLoopUsageOutputSchema = z.object({
  accepted: z.literal(true),
});
export type ReportLoopUsageOutput = z.infer<typeof ReportLoopUsageOutputSchema>;

/** Model-facing outcome of the sandbox complete_page wrapper. */
export const CompletePageResultSchema = z.discriminatedUnion("ok", [
  z.object({ ok: z.literal(true) }),
  z.object({ ok: z.literal(false), error: z.string() }),
]);
export type CompletePageResult = z.infer<typeof CompletePageResultSchema>;
